// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-text[data-v-becd6cb6] {
  font-size: 18px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.header-text .header-main[data-v-becd6cb6] {
  display: flex;
  flex: 1 1;
}
.header-text .header-main .title-block[data-v-becd6cb6] {
  margin: auto;
}
.header-text .header-back[data-v-becd6cb6] {
  margin-right: 12px;
}
.header-left-block[data-v-becd6cb6] {
  display: flex;
  cursor: pointer;
  overflow: hidden;
}
.header-btns[data-v-becd6cb6] {
  cursor: pointer;
  margin-left: auto;
  font-size: 23px;
  line-height: 24px;
  display: flex;
  align-items: center;
}
.header-btns .fa-window-maximize[data-v-becd6cb6] {
  font-size: 21px;
  color: var(--toolbtn-color);
}
.header-btns .fa-window-maximize[data-v-becd6cb6]:hover {
  color: var(--toolbtn-color-hover) !important;
}
.header-btns .audio-call[data-v-becd6cb6] {
  margin: auto;
  color: var(--toolbtn-color);
  font-size: 18px;
}
.header-btns .audio-call[data-v-becd6cb6]:hover {
  color: #353535;
}
.header-btns .close-icon[data-v-becd6cb6] {
  height: 18px;
}
.header-btns .header-chat-search[data-v-becd6cb6] {
  width: 30px;
  height: 22px;
}
.header-btns .header-chat-search[data-v-becd6cb6]:before {
  content: "\\F002";
  font-family: "Font Awesome 5 Pro";
  color: var(--toolbtn-color);
}
.header-chat-search[data-v-becd6cb6] {
  width: 30px;
  height: 22px;
  display: flex;
  justify-content: center;
}
.header-chat-search[data-v-becd6cb6]:before {
  content: "\\F002";
  font-family: "Font Awesome 5 Pro";
  color: var(--toolbtn-color);
}
`, "",{"version":3,"sources":["webpack://./js/app/components/main/header/MainHeaderContainer.vue"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,YAAY;EACZ,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,2BAA2B;AAC7B","sourcesContent":[".header-text[data-v-becd6cb6] {\n  font-size: 18px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.header-text .header-main[data-v-becd6cb6] {\n  display: flex;\n  flex: 1 1;\n}\n.header-text .header-main .title-block[data-v-becd6cb6] {\n  margin: auto;\n}\n.header-text .header-back[data-v-becd6cb6] {\n  margin-right: 12px;\n}\n.header-left-block[data-v-becd6cb6] {\n  display: flex;\n  cursor: pointer;\n  overflow: hidden;\n}\n.header-btns[data-v-becd6cb6] {\n  cursor: pointer;\n  margin-left: auto;\n  font-size: 23px;\n  line-height: 24px;\n  display: flex;\n  align-items: center;\n}\n.header-btns .fa-window-maximize[data-v-becd6cb6] {\n  font-size: 21px;\n  color: var(--toolbtn-color);\n}\n.header-btns .fa-window-maximize[data-v-becd6cb6]:hover {\n  color: var(--toolbtn-color-hover) !important;\n}\n.header-btns .audio-call[data-v-becd6cb6] {\n  margin: auto;\n  color: var(--toolbtn-color);\n  font-size: 18px;\n}\n.header-btns .audio-call[data-v-becd6cb6]:hover {\n  color: #353535;\n}\n.header-btns .close-icon[data-v-becd6cb6] {\n  height: 18px;\n}\n.header-btns .header-chat-search[data-v-becd6cb6] {\n  width: 30px;\n  height: 22px;\n}\n.header-btns .header-chat-search[data-v-becd6cb6]:before {\n  content: \"\\F002\";\n  font-family: \"Font Awesome 5 Pro\";\n  color: var(--toolbtn-color);\n}\n.header-chat-search[data-v-becd6cb6] {\n  width: 30px;\n  height: 22px;\n  display: flex;\n  justify-content: center;\n}\n.header-chat-search[data-v-becd6cb6]:before {\n  content: \"\\F002\";\n  font-family: \"Font Awesome 5 Pro\";\n  color: var(--toolbtn-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
